import { useLocation, useNavigate } from "react-router";
import Container from "../components/common/Container";
import PlusIcon from "../components/common/Icons/PlusIcon";
import PageHeader from "../components/common/PageHeader";
import DepartmentSettingsTable from "../components/Settings/Department/DepartmentSettingsTable";

const DepartmentSettings = () => {
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <Container>
      <PageHeader
        pageTitle="Departman Listesi"
        isButtoned
        buttonIcon={<PlusIcon />}
        buttonText="Yeni Departman"
        buttonOnClick={() => {
          navigate(`${location.pathname}/new`);
        }}
      />
      <DepartmentSettingsTable />
    </Container>
  );
};

export default DepartmentSettings;
